// extracted by mini-css-extract-plugin
export default {"link":"Breadcrumb_link__n9UtP"};